import {Component, OnInit} from "@angular/core";
import {New} from "./new";
import {NewService} from "./new.service";
import {Router} from "@angular/router";
declare var jquery:any; // 這邊用 var 
declare let $:any; // 當然 let 也可以
@Component({
  template:`    
    <div class="big-about">
       
        <div class="middle-box"><br>
        <h2>最新消息</h2><br>
        <div class="line-about"></div><br>
        <p>關於本店近況及商品的最新消息皆會在此不定期發佈！！！
        </p>
        </div></div>
        <div class="container">
        <div class="title-clothes">
        <div class="title-clothes-line"></div>最新消息<div class="title-clothes-line2"></div>
        </div>

        <div class="categoryBtn">
        <button class="newBtn2" (click)="gotoNew()">全部</button>

        <button class="newBtn2" (click)="gotoNew2()">活動</button>
        <button class="newBtn2" (click)="gotoNew3()">評測</button>
        <button class="newBtn2" (click)="gotoNew4()">新品</button>
        <button class="newBtn2" (click)="gotoNew5()">重要</button>
        <button class="newBtn2" (click)="gotoNew6()">情報</button>
        </div>
        <div class="cool"><button class="changefont" (click)="gotoDetail200()">2020-03-10<span class="category">重要</span><p class="cool2"></p>台北萬隆體驗店【營業時間變更公告】</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail195()">2020-01-21<span class="category">重要</span><p class="cool2"></p>春節營業時間出爐嘍‼️I can do it~再度挑戰全年無休</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail179()">2019-10-25<span class="category">重要</span><p class="cool2"></p>【波爾桌球-萬隆體驗店】國民旅遊卡開放囉！🆕💯</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail175()">2019-09-30<span class="category">重要</span><p class="cool2"></p>【波爾桌球用品專賣店】營業時間異動公告</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail133()">2019-02-11<span class="category">重要</span><p class="cool2"></p>波爾桌球『中和店』開放使用國民旅遊卡～</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail132()">2019-02-02<span class="category">重要</span><p class="cool2"></p>『萬隆店』💮農曆年節期間，2/4(一)~2/8(五)店休</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail131()">2019-02-02<span class="category">重要</span><p class="cool2"></p>『中和總店』春節營業時間出爐~首度挑戰全年無休!!</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail97()">2018-09-20<span class="category">重要</span><p class="cool2"></p>【波爾桌球中秋假期營業時間公告】</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail92()">2018-09-11<span class="category">重要</span><p class="cool2"></p>【萬隆體驗站-營業時間更改公告】</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail54()">2018-04-18<span class="category">重要</span><p class="cool2"></p>【波爾桌球用品專賣店】即將進行今年第二次改裝！</button><br><br></div>
        <div class="cool"><button class="changefont" (click)="gotoDetail47()">2018-03-26<span class="category">重要</span><p class="cool2"></p>波爾桌球「台北萬隆體驗站」4/1(日)正式開幕！</button><br><br></div>
        <div class="cool"><button class="changefont" (click)="gotoDetail37()">2018-02-10<span class="category">重要</span><p class="cool2"></p>【2018 農曆新年營業時間】</button><br><br></div>
        <div class="cool"><button class="changefont" (click)="gotoDetail12()">2017-10-08<span class="category">重要</span><p class="cool2"></p>【國慶連假營業時間異動】</button><br><br></div>
        <div class="cool"><button class="changefont" (click)="gotoDetail10()">2017-10-03<span class="category">重要</span><p class="cool2"></p>【中秋節營業時間異動】</button><br><br></div>
        <div class="cool"><button class="changefont" (click)="gotoDetail7()">2017-07-25<span class="category">重要</span><p class="cool2"></p>【營業時間更改公告】</button><br><br></div>
        <button (click)="topFunction()" id="return-to-top" title="Go to top">Top</button>

       </div>
      
    `,
  providers:[NewService],
  styles: [`    
    .cool button{
    float: left;
    background-color: white;
    margin-left: 30px;
    border: none;
    
    }
    
    .cool{
    width:700px;
    font-size: 18px;
    font-weight: bold;
    }
    
   
    .container{
    margin-bottom: 30px;
    }
    
    `],
  inputs:['ptitle','pcontent']

})

export class New5Component implements OnInit{
  constructor(private newservice:NewService,private router:Router){}
  new:New[];
  errorMessage:string;
  public ptitle:string;
  public pcontent:string;

  ngOnInit(){
    this.getNews();
  }

  select2(title:string,content:string){
    this.newservice.add(title,content);
  }

  getNews(){
    this.newservice.getNews()
      .subscribe(
        products => this.new = products,
        error =>  this.errorMessage = <any>error);


  }
  gotoNew(){
    this.router.navigate(['new']);
  }
  gotoNew2(){
    this.router.navigate(['new2']);
  }
  gotoNew3(){
    this.router.navigate(['new3']);
  }
  gotoNew4(){
    this.router.navigate(['new4']);
  }
  gotoNew5(){
    this.router.navigate(['new5']);
  }
  gotoNew6(){
    this.router.navigate(['new6']);
  }
  gotoNew7(){
    this.router.navigate(['new7']);
  }
  gotoNew8(){
    this.router.navigate(['new8']);
  }

  gotoNewDetail(){
    this.router.navigate(['newdetail']);
  }
  gotoDetail1(){
    this.router.navigate(['detail1']);
  }
  gotoDetail2(){
    this.router.navigate(['detail2']);
  }
  gotoDetail3(){
    this.router.navigate(['detail3']);
  }
  gotoDetail4(){
    this.router.navigate(['detail4']);
  }
  gotoDetail5(){
    this.router.navigate(['detail5']);
  }
  gotoDetail6(){
    this.router.navigate(['detail6']);
  }
  gotoDetail7(){
    this.router.navigate(['detail7']);
  }
  gotoDetail8(){
    this.router.navigate(['detail8']);
  }
  gotoDetail9(){
    this.router.navigate(['detail9']);
  }
  gotoDetail10(){
    this.router.navigate(['detail10']);
  }
  gotoDetail11(){
    this.router.navigate(['detail11']);
  }
  gotoDetail12(){
    this.router.navigate(['detail12']);
  }
  gotoDetail13(){
    this.router.navigate(['detail13']);
  }
  gotoDetail14(){
    this.router.navigate(['detail14']);
  }
  gotoDetail15(){
    this.router.navigate(['detail15']);
  }
  gotoDetail16(){
    this.router.navigate(['detail16']);
  }
  gotoDetail17(){
    this.router.navigate(['detail17']);
  }
  gotoDetail18(){
    this.router.navigate(['detail18']);
  }
  gotoDetail19(){
    this.router.navigate(['detail19']);
  }
  gotoDetail20(){
    this.router.navigate(['detail20']);
  }
  gotoDetail21(){
    this.router.navigate(['detail21']);
  }
  gotoDetail22(){
    this.router.navigate(['detail22']);
  }
  gotoDetail23(){
    this.router.navigate(['detail23']);
  }
  gotoDetail24(){
    this.router.navigate(['detail24']);
  }
  gotoDetail25(){
    this.router.navigate(['detail25']);
  }
  gotoDetail26(){
    this.router.navigate(['detail26']);
  }
  gotoDetail27(){
    this.router.navigate(['detail27']);
  }
  gotoDetail28(){
    this.router.navigate(['detail28']);
  }
  gotoDetail29(){
    this.router.navigate(['detail29']);
  }
  gotoDetail30(){
    this.router.navigate(['detail30']);
  }
  gotoDetail31(){
    this.router.navigate(['detail31']);
  }
  gotoDetail32(){
    this.router.navigate(['detail32']);
  }
  gotoDetail33(){
    this.router.navigate(['detail33']);
  }
  gotoDetail34(){
    this.router.navigate(['detail34']);
  }
  gotoDetail35(){
    this.router.navigate(['detail35']);
  }
  gotoDetail36(){
    this.router.navigate(['detail36']);
  }
  gotoDetail37(){
    this.router.navigate(['detail37']);
  }
  gotoDetail38(){
    this.router.navigate(['detail38']);
  }
  gotoDetail39(){
    this.router.navigate(['detail39']);
  }
  gotoDetail40(){
    this.router.navigate(['detail40']);
  }
  gotoDetail41(){
    this.router.navigate(['detail41']);
  }
  gotoDetail42(){
    this.router.navigate(['detail42']);
  }
  gotoDetail43(){
    this.router.navigate(['detail43']);
  }
  gotoDetail44(){
    this.router.navigate(['detail44']);
  }
  gotoDetail45(){
    this.router.navigate(['detail45']);
  }
  gotoDetail46(){
    this.router.navigate(['detail46']);
  }
  gotoDetail47(){
    this.router.navigate(['detail47']);
  }
  gotoDetail48(){
    this.router.navigate(['detail48']);
  }
  gotoDetail49(){
    this.router.navigate(['detail49']);
  }
  gotoDetail50(){
    this.router.navigate(['detail50']);
  }
  gotoDetail51(){
    this.router.navigate(['detail51']);
  }
  gotoDetail52(){
    this.router.navigate(['detail52']);
  }
  gotoDetail53(){
    this.router.navigate(['detail53']);
  }
  gotoDetail54(){
    this.router.navigate(['detail54']);
  }
  gotoDetail55(){
    this.router.navigate(['detail55']);
  }
  gotoDetail56(){
    this.router.navigate(['detail56']);
  }
  gotoDetail57(){
    this.router.navigate(['detail57']);
  }
  gotoDetail58(){
    this.router.navigate(['detail58']);
  }
  gotoDetail59(){
    this.router.navigate(['detail59']);
  }
  gotoDetail60(){
    this.router.navigate(['detail60']);
  }
  gotoDetail61(){
    this.router.navigate(['detail61']);
  }
  gotoDetail62(){
    this.router.navigate(['detail62']);
  }
  gotoDetail63(){
    this.router.navigate(['detail63']);
  }
  gotoDetail64(){
    this.router.navigate(['detail64']);
  }
  gotoDetail65(){
    this.router.navigate(['detail65']);
  }
  gotoDetail66(){
    this.router.navigate(['detail66']);
  }
  gotoDetail67(){
    this.router.navigate(['detail67']);
  }
  gotoDetail68(){
    this.router.navigate(['detail68']);
  }
  gotoDetail69(){
    this.router.navigate(['detail69']);
  }
  gotoDetail70(){
    this.router.navigate(['detail70']);
  }
  gotoDetail71(){
    this.router.navigate(['detail71']);
  }
  gotoDetail72(){
    this.router.navigate(['detail72']);
  }
  gotoDetail73(){
    this.router.navigate(['detail73']);
  }
  gotoDetail74(){
    this.router.navigate(['detail74']);
  }
  gotoDetail75(){
    this.router.navigate(['detail75']);
  }
  gotoDetail76(){
    this.router.navigate(['detail76']);
  }
  gotoDetail77(){
    this.router.navigate(['detail77']);
  }
  gotoDetail78(){
    this.router.navigate(['detail78']);
  }
  gotoDetail79(){
    this.router.navigate(['detail79']);
  }
  gotoDetail92(){
    this.router.navigate(['detail92']);
  }
  gotoDetail97(){
    this.router.navigate(['detail97']);
  }
  gotoDetail131(){
    this.router.navigate(['detail131']);
  }
  gotoDetail132(){
    this.router.navigate(['detail132']);
  }
  gotoDetail133(){
    this.router.navigate(['detail133']);
  }
  gotoDetail175(){
    this.router.navigate(['detail175']);
  }
  gotoDetail179(){
    this.router.navigate(['detail179']);
  }
  gotoDetail195(){
    this.router.navigate(['detail195']);
  }
  gotoDetail200(){
    this.router.navigate(['detail200']);
  }
  topFunction() {
    $('body,html').animate({
      scrollTop : 0                       // Scroll to top of body
  }, 500);
}

}



// WEBPACK FOOTER //
// ./src/app/news/new5.component.ts